import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]";
const empty = { title: "", subtitle: "", image_url: "", cta_label: "", cta_url: "", is_active: true, order: 0 };

export default function AdminBanners() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/admin/banners").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, order: Number(form.order) };
    try {
      if (editId) await api.put(`/admin/banners/${editId}`, payload);
      else await api.post("/admin/banners", payload);
      toast.success("Kaydedildi");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <div className="flex justify-between mb-6 items-center">
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Bannerlar</h1>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <button onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} className="btn-primary"><Plus size={16}/> Yeni</button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editId ? "Banner Düzenle" : "Yeni Banner"}</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Başlık" className={inputCls} value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} />
              <input placeholder="Alt başlık" className={inputCls} value={form.subtitle} onChange={(e) => setForm({...form, subtitle: e.target.value})} />
              <input required placeholder="Görsel URL" className={inputCls} value={form.image_url} onChange={(e) => setForm({...form, image_url: e.target.value})} />
              <div className="grid grid-cols-2 gap-3">
                <input placeholder="CTA Etiket" className={inputCls} value={form.cta_label} onChange={(e) => setForm({...form, cta_label: e.target.value})} />
                <input placeholder="CTA URL" className={inputCls} value={form.cta_url} onChange={(e) => setForm({...form, cta_url: e.target.value})} />
              </div>
              <input type="number" placeholder="Sıra" className={inputCls} value={form.order} onChange={(e) => setForm({...form, order: e.target.value})} />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.is_active} onChange={(e) => setForm({...form, is_active: e.target.checked})} /> Aktif</label>
              <button className="btn-primary w-full">Kaydet</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {list.map((b) => (
          <div key={b.id} className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
            <img src={b.image_url} alt={b.title} className="w-full aspect-[3/1] object-cover" />
            <div className="p-4">
              <div className="font-display font-bold">{b.title}</div>
              <div className="text-xs text-slate-500 mb-2">{b.subtitle}</div>
              <div className="flex gap-2">
                <button onClick={() => { setForm(b); setEditId(b.id); setOpen(true); }} className="text-[#0077B6] text-sm font-semibold"><Edit size={13}/></button>
                <button onClick={async () => { if(window.confirm("Sil?")) { await api.delete(`/admin/banners/${b.id}`); load(); }}} className="text-rose-600 text-sm font-semibold ml-auto"><Trash2 size={13}/></button>
              </div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="bg-white rounded-2xl p-10 text-center text-slate-600 md:col-span-2">Banner yok.</div>}
      </div>
    </div>
  );
}
